export const computerSeoConfig = {
  siteSection: "Computer Learning System",
  titleTemplate: (title: string) => `${title} | 11th Class Computer | Ustaad`,
  descriptions: {
    hub: "11th class computer ke core concepts Roman Urdu mein, chapter shells aur concept clusters ke sath.",
    python: "Python chapter ka guided shell jahan se aap variables, input output, operators, if else aur loops tak ja sakte ho.",
    class11: "1st year computer ka overview, learning path aur Python chapter ki navigation.",
  },
  structuredData: {
    webPage: {
      "@type": "WebPage",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
    },
    itemList: {
      "@type": "ItemList",
    },
  },
};
